import { __assign } from "tslib";
import { EVENTS_WEB_API_BASE } from './endpoints';
var EventsHttpClient = /** @class */ (function () {
    function EventsHttpClient(controllerParams, baseUrl, linguisticHeader) {
        var _this = this;
        if (baseUrl === void 0) { baseUrl = EVENTS_WEB_API_BASE; }
        this.controllerParams = controllerParams;
        this.baseUrl = baseUrl;
        this.linguisticHeader = linguisticHeader;
        this.getHeaders = function () {
            return {
                headers: { 'x-wix-linguist': _this.linguisticHeader },
            };
        };
        this.makeRequest = function (_a) {
            var url = _a.url, method = _a.method, _b = _a.data, data = _b === void 0 ? {} : _b;
            return _this.httpClient
                .request(__assign({ url: "" + _this.baseUrl + url, method: method,
                data: data }, _this.getHeaders()))
                .then(function (response) { return response.data; })
                .catch(function (error) {
                if (error.response) {
                    throw { payload: error.response.data };
                }
            });
        };
        this.httpClient = this.controllerParams.flowAPI.httpClient;
    }
    EventsHttpClient.prototype.get = function (url) {
        return this.makeRequest({ url: url, method: 'GET' });
    };
    EventsHttpClient.prototype.delete = function (url, data) {
        return this.makeRequest({ url: url, method: 'DELETE', data: data });
    };
    EventsHttpClient.prototype.put = function (url, data) {
        return this.makeRequest({ url: url, method: 'PUT', data: data });
    };
    EventsHttpClient.prototype.post = function (url, data) {
        return this.makeRequest({ url: url, method: 'POST', data: data });
    };
    EventsHttpClient.prototype.patch = function (url, data) {
        return this.makeRequest({ url: url, method: 'PATCH', data: data });
    };
    return EventsHttpClient;
}());
export { EventsHttpClient };
//# sourceMappingURL=http-client.js.map